import { memo, type PropsWithChildren } from "react";
import Typography from "@mui/material/Typography";

const Label = ({ children }: PropsWithChildren) => (
    <Typography
        variant='caption'
        sx={{
            fontWeight: 600,
            fontSize: 12,
            textTransform: 'uppercase'
        }}
    >
        {children}
    </Typography>
);

export default memo(Label);
